module.exports = __webpack_public_path__ + "static/lights-out@3x.5c5e460a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bedroom/lights-out@3x.png
// module id = 577
// module chunks = 6850842914447